<template>
  <b-row>
    <b-col>
      <div class="table-responsive">
        <table class="table table-striped table-hover">
          <thead>
          <tr>
            <th>car</th>
            <th>userData</th>
            <th>dateFrom</th>
            <th>dateTo</th>
            <th colspan="2" />
          </tr>
          </thead>
          <tbody>
          <tr
                  v-for="item in items"
                  :key="item['@id']">
            <td>
              <router-link
                      v-if="item"
                      :to="{name: 'EXCMCarUserDataShow', params: { id: item['@id'] }}">
                {{ item['car'] }}
              </router-link>
            </td>
            <td>
              <router-link
                      v-if="item"
                      :to="{name: 'EXCMCarUserDataShow', params: { id: item['@id'] }}">
                {{ item['userData'] }}
              </router-link>
            </td>
            <td>
              <router-link
                      v-if="item"
                      :to="{name: 'EXCMCarUserDataShow', params: { id: item['@id'] }}">
                {{ item['dateFrom'] }}
              </router-link>
            </td>
            <td>
              <router-link
                      v-if="item"
                      :to="{name: 'EXCMCarUserDataShow', params: { id: item['@id'] }}">
                {{ item['dateTo'] }}
              </router-link>
            </td>
            <td>
              <router-link
                      :to="{name: 'EXCMCarUserDataShow', params: { id: item['@id'] }}">
                <span
                        class="fa fa-search"
                        aria-hidden="true" />
                <span class="sr-only">Show</span>
              </router-link>
            </td>
            <td>
              <router-link :to="{name: 'EXCMCarUserDataUpdate', params: { id: item['@id'] }}">
                <span
                        class="fa fa-pencil"
                        aria-hidden="true" />
                <span class="sr-only">Edit</span>
              </router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <router-link :to="{ name: 'EXCMCarUserDataCreate' }" class="btn btn-primary">{{ $t('buttons.create') }}</router-link>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    deletedItem: 'excmcaruserdata/del/deleted',
    error: 'excmcaruserdata/list/error',
    items: 'excmcaruserdata/list/items',
    isLoading: 'excmcaruserdata/list/isLoading',
    view: 'excmcaruserdata/list/view'
  }),

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'excmcaruserdata/list/default'
  })
}
</script>
